import React, {useEffect, useState} from 'react';
import {Button, Card, CardBody, Container} from "reactstrap";
import {useHistory} from "react-router-dom";
import frame from "../../assets/img/backgrounds/Frame.png";
import logo from "../../assets/img/icons/user/activ8Logo.png";
import {getDb} from 'util/Constants';
import {doc, getDoc} from 'firebase/firestore';

const Start = ({ userData, setUserData }) => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const db = getDb();


    useEffect(() => {

    }, [userData])
    const generateEventId = async () => {
        setLoading(true)

        const _eventId = Math.floor(1000 + Math.random() * 9000).toString();
        const docRef = doc(db, "event", _eventId);

        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {

            await generateEventId();
        } else {
            setUserData({ ...userData, eventData: { eventId: _eventId } });
            setLoading(false);
            history.push('/easy-flow/step1')
        }

    }

    return (
        <div className="">
            <Container className="d-flex justify-content-center">
                <Card className="br-60 mt--200 step1-card">
                    <CardBody className="startCard">
                        <Container className="px-4">
                            <h1 className="display-3 mb-4">Build and release your own engaging assessments solution</h1>
                            <p className="font-weight-normal mb-5 startInfo">Effortlessly evaluate individuals,
                                regardless of their location or schedule, using any of
                                our versatile tests. Just using 4 simple stages, our assessment platform offers
                                extensive customization options and is specifically designed to captivate
                                candidates.</p>
                            <div className="text-center text-lg-left text-md-left">
                                <Button onClick={generateEventId} className="beginBtn  startButton" color="">
                                    {loading ? <span className="text-white font-weight-normal">Please wait..</span> :
                                        <span className="text-white font-weight-normal">Lets begin!</span>}
                                </Button>
                            </div>
                        </Container>
                    </CardBody>
                </Card>
            </Container>
            <div className="d-none d-lg-block d-xl-block ">
                <div className="logo-div fixed-bottom pl-5 pb-5">
                    <img src={logo} />
                </div>
                <img src={frame} className=" startFrame" />
            </div>
        </div>
    );
};

export default Start;